import classNames from 'classnames/bind'
import { ReactNode } from 'react'

import { SnippetCarouselItem } from './snippet-carousel-item'
import styles from './snippet-carousel-item-bordered.module.scss'

const cx = classNames.bind(styles)

export interface SnippetCarouselItemBorderedProps {
  children: ReactNode
  className?: string
}

export function SnippetCarouselItemBordered(props: SnippetCarouselItemBorderedProps) {
  const { children, className } = props
  return (
    <SnippetCarouselItem className={cx('SnippetCarouselItemBordered', className)}>
      {children}
    </SnippetCarouselItem>
  )
}
